<template>
  <div
    class="license-verified"
    :class="{ 'd-inline-flex': isIconVariant }"
  >
    <div
      v-if="isIconVariant"
      class="license-verified__icon ui-icon-shield-checkmark-40 success--text flex-shrink-0 cursor-pointer"
      role="button"
      tabindex="0"
      :aria-label="translate('Лицензия проверена')"
      data-qa="license-verified-icon"
      @click="isOpened = true"
      @keydown.enter.prevent="isOpened = true"
      @keydown.space.prevent="isOpened = true"
    />

    <div
      v-else
      class="d-flex align-center gc-2 rounded px-2 py-1 bg-success cursor-pointer text-success--text"
      data-qa="license-verified-plate"
      @click="isOpened = true"
    >
      <div class="ui-icon-shield-check ui-icon-fz-medium flex-shrink-0" />
      <div class="text-body-2">
        {{ translate('Лицензия проверена') }}
      </div>
    </div>

    <component
      :is="isMobile ? CoreBottomSheet : CoreDialog"
      v-model="isOpened"
      v-bind="isMobile ? {} : {
        title: translate('Лицензия проверена'),
        divider: true,
        size: 'md',
      }"
    >
      <template
        v-if="!isMobile"
        #prependBtn="{ btnProps }"
      >
        <v-btn
          v-bind="btnProps"
          @click="isOpened = false"
        >
          <span class="ui-icon-close-not-a-circle" />
        </v-btn>
      </template>

      <div
        v-if="isMobile"
        class="d-flex align-center gc-4 mb-2"
      >
        <v-icon
          color="success"
          size="24"
        >
          ui-icon-shield-checkmark-40
        </v-icon>
        <div class="text-h6 text-success--text">
          {{ translate('Лицензия проверена') }}
        </div>
      </div>

      <div class="text-body-1 text-secondary--text">
        {{ translate('Лицензия клиники:') }}
        <br>{{ license }}
      </div>

      <template #actions>
        <v-btn
          class="primary--text branding-btn branding-btn--background"
          color="bg-primary"
          depressed
          block
          @click="isOpened = false"
        >
          {{ translate('Хорошо') }}
        </v-btn>
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  ref,
} from 'vue'
import i18next from 'i18next'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import useIsMobile from 'src/composables/useIsMobile'

const { t, language } = i18next
const l10nOptions = { ns: language }

const translate = (key: string) => t(key, l10nOptions) || key

const props = withDefaults(defineProps<{
  license: string
  variant?: 'plate' | 'icon'
}>(), {
  variant: 'plate',
})

const isIconVariant = computed(() => props.variant === 'icon')

const isOpened = ref(false)
const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.license-verified {
  &__icon {
    font-size: 18px;
    line-height: 1;
  }
}
</style>
